import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromOrganization from '../organization/organization.reducer'
import { OrganizationCreateComponent } from './create/show.component'
import { OrganizationFormComponent } from './form/form.component'
import { OrganizationGeneralTabComponent } from './general-tab/show.component'
import { OrganizationIndexComponent } from './index/index.component'
import { OrganizationRelationEffects } from './organization-relation.effects'
import { OrganizationRoutingModule } from './organization-routing.module'
import { OrganizationEffects } from './organization.effects'
import { OrganizationSerializer } from './organization.serializer'
import { OrganizationService } from './organization.service'
import { OrganizationShowComponent } from './show/show.component'
import { OrganizationTableComponent } from './table/table.component'
import { RoleModule } from '../role/role.module'
import { UserRoleModule } from '../role/user-role/user-role.module'
import { OrganizationUserRolesTabComponent } from './user-roles-tab/show.component'
import { OrganizationSaleTabComponent } from './sale-tab/show.component'
import { SaleModule } from '../sale/sale.module'
import { SubscriptionModule } from '../subscription/subscription.module'
import { OrganizationRequiredSubscriptionTabComponent } from './required-subscription-tab/show.component'
import { OrganizationRequiredSubscriptionService } from './organization-required-subscription.service'
import { OrganizationDocumentService } from './organization-document.service'
import { DocumentModule } from '../document/document.module'
import { OrganizationDocumentsTabComponent } from './documents-tab/show.component'
import { OrganizationActivitiesTabComponent } from './activities-tab/show.component'
import { ActivityModule } from '../activity/activity.module'
import { AddressModule } from '../address/address.module'
import { OrganizationAddressesTabComponent } from './addresses-tab/show.component'
import { OrganizationBookingTabComponent } from './booking-tab/booking-tab.component'
import { CommonComponentsModule } from 'src/app/common-components/common-components.module'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { ShowModalModule } from './show-modal/ShowModal.module'

@NgModule({
  imports: [
    OrganizationRoutingModule,
    RoleModule,
    UserRoleModule,
    SharedModule,
    CommonComponentsModule,
    StoreModule.forFeature(
      fromOrganization.FEATURE_NAME,
      fromOrganization.organizationReducer
    ),
    EffectsModule.forFeature([
      OrganizationEffects,
      OrganizationRelationEffects
    ]),
    SaleModule,
    SubscriptionModule,
    DocumentModule,
    ActivityModule,
    AddressModule,
    NzDatePickerModule,
    ShowModalModule
  ],
  declarations: [
    OrganizationIndexComponent,
    OrganizationFormComponent,
    OrganizationTableComponent,
    OrganizationShowComponent,
    OrganizationGeneralTabComponent,
    OrganizationUserRolesTabComponent,
    OrganizationCreateComponent,
    OrganizationSaleTabComponent,
    OrganizationRequiredSubscriptionTabComponent,
    OrganizationDocumentsTabComponent,
    OrganizationActivitiesTabComponent,
    OrganizationAddressesTabComponent,
    OrganizationBookingTabComponent
  ],
  exports: [
    OrganizationTableComponent,
    OrganizationIndexComponent,
    OrganizationFormComponent,
    OrganizationAddressesTabComponent
  ],
  providers: [
    OrganizationService,
    OrganizationDocumentService,
    {
      provide: OrganizationSerializer,
      useClass: OrganizationSerializer
    },
    OrganizationRequiredSubscriptionService
  ]
})
export class OrganizationModule {}
